import type { IconName } from '@customerio/pluma-icons';
import type { ChannelEvent } from './events';

/** The identity facet of a messaging channel. */
export type ChannelDefinition = {
  /** The channel's id, as the API spells it (`email`, `twilio`, `in_app`). */
  readonly id: string;
  /** The icon that stands for the channel wherever it is listed. */
  readonly icon: IconName;
  /** The channel's human name, as a channel list or filter shows it. */
  readonly name: string;
  /** The channel's short name, as a placeholder or inline label shows it. */
  readonly shortName: string;
  /** What one of the channel's messages is called mid-sentence: "Sent {noun}", "any {noun}". */
  readonly noun: string;
  /** The events the channel's activity log records, each as the log type `${event}_${id}`. */
  readonly events: readonly ChannelEvent[];
};

/** Declares one channel. Pass the definition `as const satisfies ChannelDefinition` so its literals survive. */
export function defineChannel<Definition extends ChannelDefinition>(definition: Definition): Definition {
  return definition;
}
